const initialState = () => ({
  lead: {},
  alert: {},
  cycles: [],
  customer: {},
  hvac: {},
  address: {},
  pastAlerts: [],
  leakEvents: [],
  batteryStatus: '',
  leakLocation: 'Sink',
  loading: true,
  pressureConversion: 248.84,
});

export default initialState;
